import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

type D3TableProps = {
  headers: string[];
  data: { [key: string]: string | number }[];
  className?: string;
};

const D3Table: React.FC<D3TableProps> = ({ headers, data, className }) => {
  const tableRef = useRef<HTMLTableElement>(null);

  useEffect(() => {
    if (!tableRef.current) return;
    d3.select(tableRef.current).selectAll("*").remove();

    // table 생성
    const table = d3.select(tableRef.current)
      .style("border-collapse", "collapse")
      .style("width", "100%")
      .style("font-size", "1rem")
      .style("color", "#FFF")
      .style("margin-top", "4px");

    // thead
    const thead = table.append("thead");
    thead.append("tr")
      .selectAll("th")
      .data(headers)
      .enter()
      .append("th")
      .text(d => d)
      .style("padding", "4px 8px");

    // tbody
    const tbody = table.append("tbody");
    const rows = tbody.selectAll("tr")
      .data(data)
      .enter()
      .append("tr");

    rows.selectAll("td")
      .data(row => headers.map(h => row[h] ?? ""))
      .enter()
      .append("td")
      .text(d => d as string)
      .style("padding", "4px 8px");
  }, [headers, data]);

  return (
    <table ref={tableRef} className={className} />
  );
};

export default D3Table;
